/**
 * DEFINICIONES DE PÁGINAS
 * Configuración de todas las páginas del sitio
 */

import { color } from "motion";

export const pages = {
  //**
  // */ Páginas Base
  //

  home: {
    title: "Zero Latency MTY - Realidad Virtual Inmersiva",
    description:
      "Experimenta la mejor realidad virtual en Monterrey. Juegos inmersivos, tecnología de punta y aventuras inolvidables.",
    keywords: [
      "realidad virtual",
      "VR",
      "Monterrey",
      "gaming",
      "experiencias inmersivas",
    ],
    sections: [
      // Hero
      {
        type: "hero",
        id: "hero-home",
        data: {
          title: "DESPERTAR",
          subtitle: "¿QUÉ HAY DeNTRO?",
          description:
            "DESCUBRE UN NUEVO YO EN NUESTRA SORPRENDENTE REALIDAD VIRTUAL INMERSIVA",
          responsiveMedia: {
            desktop: "/images/Desktop/Home/Home-Banner.webp",
            mobile: "/images/Mobile/Home/Home-Banner.webp",
          },
          // Fallback para compatibilidad
          backgroundMedia: "/images/Desktop/Home/Home-Banner.webp",
          ctaButton: {
            text: "¡RESERVA YA!",
            variant: "accent",
            size: "small",
          },
        },
      },
      // Video
      {
        type: "video-section",
        id: "video-section",
        data: {
          videoUrl: "/videos/HomeVideo.mp4",
          placeholder: false,
          backgroundColor: "#00202C",
          borderRadius: "lg",
          maxWidth: "6xl",
          autoplay: true,
          controls: true,
          loop: false,
          muted: true,
          poster: null,
        },
      },
      // Features
      {
        type: "features-section",
        id: "main-features",
        data: {
          backgroundColor: "#00202C",
          features: [
            {
              title: "ENTRA EN NUEVOS MUNDOS",
              description:
                "Prepárate para conocer otro lado de ti mientras te adentras en realidades inimaginables. Desde vagar por mundos de rompecabezas para toda la familia hasta enfrentarte a hordas de zombis no tan amistosos, es hora de despertar lo que hay en tu interior.",
              image: "/images/Desktop/Home/Home-Feature1.webp",
            },
            {
              title: "Sumérgete en nuestro espacio",
              description:
                "Imagínate entrar a un estadio del tamaño de una cancha de tenis donde puedes correr libre... y salvaje. Mira el horizonte, deambula, siéntete totalmente inmerso en nuevos universos.Todo sin cables, alambres, trajes incómodos o mochilas. ¡Solo tú y tus amigos pasándolo genial!",
              image: "/images/Desktop/Home/Home-Feature2.webp",
            },
            {
              title: "DIFUMINAR LA REALIDAD",
              description:
                "Entra en lo desconocido y siente que realmente estás allí. Te sorprenderá el detalle gráfico y el sonido espacial envolvente de nuestro equipo. Todo lo que necesitas es coger tu mando y despertar al buscador de emociones que llevas dentro.",
              image: "/images/Desktop/Home/Home-Feature3.webp",
            },
          ],
        },
      },
      // Testimonios
      {
        type: "testimonial-section",
        id: "testimonios-eventos",
        data: {
          topColor: "#00202C",
          bottomColor: "#00202C",
          backgroundColor: "#F5F5F5",
          autoplay: true,
          autoplaySpeed: 15000,
          showDots: true,
          showArrows: true,
          effect: "slide",
          testimonials: [
            {
              name: "Jonelle",
              text: "Hicimos un evento para 14 personas y fue un hit. Nos dividimos en dos sesiones de zombies y todos salieron sudando y riéndose. La libertad de moverte sin cables lo cambia todo. ¡Volveremos seguro! 🧟‍♂️😂",
              rating: 5,
              avatar: null,
              position: "Team Event Organizer",
              date: "2024-08-12",
            },
            {
              name: "Luis A.",
              text: "Celebramos el cumple 12 de mi hijo. El staff súper atento y paciente. Engineerium fue ideal para los peques y los adultos nos aventamos Outbreak. ¡Fiesta redonda! 🎂🎉",
              rating: 5,
              avatar: null,
              position: "Papá de cumpleañero",
              date: "2025-01-14",
            },
            {
              name: "Carla R.",
              text: "Far Cry® VR nos voló la cabeza. Tracking estable, cero cables, briefing claro y partida intensa. Ideal para venir con amigos y grabar reacciones. 🎮🔥",
              rating: 5,
              avatar: null,
              position: "Streamer y gamer",
              date: "2024-11-22",
            },
            {
              name: "Diego M.",
              text: "Fui con mi esposa y dos hijos adolescentes. Reímos, gritamos y cooperamos como equipo. Seguro, bien guiado y con equipos de primera. 👨‍👩‍👧‍👦",
              rating: 5,
              avatar: null,
              position: "Padre de familia",
              date: "2023-11-02",
            },
            {
              name: "María P.",
              text: "Para team building es perfecto: check-in ágil, entrenamiento breve y mecánicas que obligan a comunicarse. El feedback del equipo fue excelente. 🤝",
              rating: 5,
              avatar: null,
              position: "Líder de RR. HH.",
              date: "2025-03-10",
            },
            {
              name: "Prof. Hernández",
              text: "Traje a mi grupo como salida escolar. Outbreak fomentó coordinación, roles y comunicación bajo presión. Aprendizaje + diversión en una sola actividad. 🧑‍🏫",
              rating: 4,
              avatar: null,
              position: "Profesor de secundaria",
              date: "2024-07-28",
            },
            {
              name: "Renata G.",
              text: "Space Marine VR fue una cita diferente y adrenalínica. Sin cables te mueves natural y te metes de lleno en la misión. ¡Planazo! 💑🚀",
              rating: 5,
              avatar: null,
              position: "Date night",
              date: "2025-06-20",
            },
            {
              name: "Álvaro T.",
              text: "No es la VR de casa. Aquí caminas de verdad por el escenario y eso hace toda la diferencia. Experiencia inmersiva y bien producida.",
              rating: 5,
              avatar: null,
              position: "Viajero",
              date: "2023-08-15",
            },
          ],
        },
      },
      // Games Showcase
      {
        type: "games-showcase",
        id: "games-showcase",
        data: {
          backgroundColor: "#00202C",
          title: "SIENTE LA ADRENALINA",
          subtitle: "¡Descubre tu aventura perfecta!",
          games: [
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
            {
              title: "Zombies",
              description:
                "Un juego de survival horror en primera persona. ¡Muerde a todos los zombies que puedas!",
              image: "/images/games/zombies.png",
            },
          ],
          ctaButtons: [
            {
              background: "accent",
              text: "¡RESERVAR AHORA!",
              color: "white",
              size: "small",
            },
            {
              text: "EXPLORA MÁS",
              variant: "outline",
              color: "white",
              size: "small",
            },
          ],
        },
      },
      // CTA
      {
        type: "c-t-a-wave",
        id: "cta-wave",
        data: {
          topColor: "#00202C",
          bottomColor: "#000000",
          backgroundColor: "#40C0F0",
          title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
          description:
            "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento",
          ctaButton: {
            text: "LIDERA TU VENUE",
            size: "small",
            icon: "ExternalIcon",
          },
        },
      },
    ],
  },
  queEsperar: {
    title: "Qué Esperar - Zero Latency MTY",
    description:
      "Descubre qué puedes esperar de tu experiencia de realidad virtual en Zero Latency Monterrey.",
    keywords: [
      "qué esperar",
      "experiencia VR",
      "realidad virtual",
      "preparación",
    ],
    sections: [
      {
        type: "page-banner",
        id: "que-esperar-banner",
        data: {
          title: "PREPÁRATE PARA LA AVENTURA",
          subtitle:
            "PREPÁRATE: EL IMPRESIONANTE FUTURO DE LA REALIDAD VIRTUAL TE DEJARÁ SIN ALIENTO.",
          responsiveImage: {
            mobile: "/images/Mobile/QueEsperar/QueEsperar-Banner.webp",
            desktop: "/images/Desktop/QueEsperar/QueEsperar-Banner.webp",
          },
          backgroundImage: "/images/Desktop/QueEsperar/QueEsperar-Banner.webp",
        },
      },
      {
        type: "text-section",
        id: "ejemplo-texto",
        data: {
          title: "¡ENTÉRATE DE TODO!",
          description:
            "Vive una inmersión total y absoluta mientras te enfrentas a nuevos mundos y alucinantes aventuras con precisión milimétrica. Nuestra pionera arena de 360° difumina la línea entre realidad y fantasía, dándote libertad total de movimiento. No te preocupes si nunca has probado la VR: desde el primer momento, tu anfitrión personal te acompañará en cada paso, desde que te equipas hasta tu victoria final.",
          backgroundColor: "#00202C",
          textColor: "white",
          textAlign: "start",
        },
      },
      {
        type: "video-section",
        id: "video-section",
        data: {
          videoUrl:
            "https://videos.ctfassets.net/adsfyhieuvzo/7DkLIU81dYdW5QvyAwPjqF/65c51598b0a4fac533f39fead64fc58a/h264_960.mp4",
          placeholder: false,
          backgroundColor: "#00202C",
          borderRadius: "3xl",
          maxWidth: "7xl",
          autoplay: true,
          controls: true,
          loop: false,
          muted: true,
          poster: null,
        },
      },
      {
        type: "text-with-cards-section",
        id: "proceso-experiencia",
        data: {
          title: "¡DÍA DE ACCIÓN!",
          description:
            "Únete a tus colegas como auténticos camaradas. Lucha por tus compañeros como verdaderos hermanos. Todo es posible cuando te enfrentas a zombis que hielan la sangre, escapas por los pelos de piratas desquiciados o reúnes a tribus perdidas en la aventura.",
          backgroundColor: "#F5F5F5",
          textAlign: "start",
          maxWidth: "6xl",
          cards: [
            {
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/6ti47mUTa0TKCcmgmzMOZO/df140a6a43dc07c489161c3deabb98de/ZL-website-illustrations_1_desktop.jpg?w=300&fm=webp",
              imageAlt: "Prepárate para la misión",
              title: "PREPÁRATE PARA LA MISIÓN",
              description:
                "Preséntate 10-15 minutos antes de tu reserva para registrarte, conocer a tu líder de misión y recibir tu briefing de aventura.",
            },
            {
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/2bBrj263VN0GthUrZYnLW9/f33e1be0bde8a1e1187134775713a505/ZL-website-illustrations_2_desktop.jpg?w=300&fm=webp",
              imageAlt: "¡Equípate!",
              title: "¡EQUÍPATE!",
              description:
                "Nuestro equipo te ayudará a equiparte con la tecnología más avanzada. Todo completamente inalámbrico.",
            },
            {
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/2Cs2xtUx9YAesUOkwpQcq1/e3d94645eaf4778cc13786b428fc7f84/ZL-website-illustrations_3_desktop.jpg?w=300&fm=webp",
              imageAlt: "¡Vive la acción!",
              title: "¡VIVE LA ACCIÓN!",
              description:
                "Adéntrate en mundos increíbles y vive aventuras que jamás olvidarás. La realidad nunca fue tan emocionante.",
            },
            {
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/7GDWPkDpbAejEoZTLnI7I2/1965db0306589dd4e5703167fd9a5def/ZL-website-illustrations_4_desktop.jpg?w=300&fm=webp",
              imageAlt: "Comparte tu experiencia",
              title: "COMPARTE TU EXPERIENCIA",
              description:
                "Revisa tus estadísticas, toma fotos épicas y comparte tu experiencia con el mundo. ¡Querrás volver por más!",
            },
          ],
        },
      },
      {
        type: "text-section",
        id: "wte-info",
        data: {
          title: "EQUIPO DE COMBATE",
          subtitle:
            "Libera tu verdadera libertad con una inmersión 5K sin límites",
          description:
            "En la nueva generación de realidad virtual, menos significa más libertad para desatar tu potencial. Sin cables ni mochilas que te limiten, nada se interpone entre tú y una experiencia inmersiva que elevará tus aventuras a un nivel extraordinario.",
          backgroundColor: "#00202C",
          textColor: "white",
          textAlign: "center",
        },
      },
      {
        type: "video-section",
        id: "video-section",
        data: {
          videoUrl:
            "https://videos.ctfassets.net/adsfyhieuvzo/xjnfdNZC5h5nBRd08Ahi8/85d0c07662d3ec77fc6482cb54cdebf4/ZER0018_Gear_Video_Cut_06_1080p_lq.webm",
          placeholder: false,
          backgroundColor: "#00202C",
          borderRadius: "lg",
          autoplay: true,
          controls: true,
          loop: false,
          muted: true,
          poster: null,
        },
      },
      {
        type: "image-carousel-section",
        id: "img-gallery",
        data: {
          maxWidth: "6xl",
          textColor: "white",
          images: [
            {
              src: "https://images.ctfassets.net/adsfyhieuvzo/5srKAHD4CfdlFY0Lj55dur/ed4c0737db5318f008374cf73fb46cc5/Entrance-Gen-3-Docklands-Venue__1__copy_16.9_700x394.jpg?w=720&h=600&fm=webp",
              alt: "Experiencia VR 1",
            },
            {
              src: "https://images.ctfassets.net/adsfyhieuvzo/59cTaUUeFwugyfl2J2R1N2/e6523ef873b70808e8e390d3fa3d6f05/240522_ZeroLatency_S10_HALLWAY_1623_16.9_700x394.jpg?w=720&h=600&fm=webp",
              alt: "Experiencia VR 2",
            },
            {
              src: "https://images.ctfassets.net/adsfyhieuvzo/1glm8aOIzbqxrnb2Qz10st/9791e5433876a8bbec7ec0f60a557081/240522_ZeroLatency_S04_SOL_RAIDERS_775_16.9_700x394.jpg?w=720&h=600&fm=webp",
              alt: "Experiencia VR 3",
            },
            {
              src: "https://images.ctfassets.net/adsfyhieuvzo/48Ut9Je2i6VqediZhU0TzX/7459d5d5e2dd5f2c3f109a146d727733/240522_ZeroLatency_S07__1455_16.9_700x394.jpg?w=720&h=600&fm=webp",
              alt: "Experiencia VR 4",
            },
          ],
          padding: "py-16",
        },
      },
      {
        type: "c-t-a-wave",
        id: "que-esperar-cta",
        data: {
          topColor: "#00202C",
          bottomColor: "#000000",
          backgroundColor: "#40C0F0",
          title: "PREGUNTAS FRECUENTES",
          description:
            "¡Descubre todo lo que necesitas saber sobre tu aventura en Zero Latency en nuestras preguntas frecuentes!",
          ctaButton: {
            text: "DESCRUBRE MÁS",
          },
          layout: "center",
        },
      },
    ],
  },
  experiencias: {
    title: "Experiencias VR - Zero Latency MTY",
    description:
      "Descubre todas nuestras experiencias de realidad virtual: desde aventuras familiares hasta intensas batallas.",
    keywords: [
      "experiencias VR",
      "juegos realidad virtual",
      "Outbreak",
      "Space Marine",
      "Engineerium",
    ],
    sections: [],
  },
  ubicaciones: {
    title: "Ubicaciones - Zero Latency MTY",
    description:
      "Encuentra Zero Latency en Monterrey. Ubicación, horarios y cómo llegar.",
    keywords: [
      "ubicación",
      "dirección",
      "horarios",
      "cómo llegar",
      "Monterrey",
    ],
    sections: [
      {
        type: "page-banner",
        id: "ubicaciones",
        data: {
          title: "Ubicaciones de Zero Latency",
          mediaType: "image",
          backgroundImage:
            "/images/Desktop/Ubicaciones/Ubicaciones-Banner.webp",
          responsiveMedia: {
            desktop: "/images/Desktop/Ubicaciones/Ubicaciones-Banner.webp",
            mobile: "/images/Mobile/Ubicaciones/Ubicaciones-Banner.webp",
          },
        },
      },
      {
        type: "text-section",
        id: "ubicaciones-texto",
        data: {
          title: "DESCUBRE UBICACIONES EN",
          ctaButton: {
            text: "SELECCIONAR UN PAÍS",
            variant: "outline",
            color: "white",
            icon: "LocationIcon",
            iconPosition: "left",
            size: "small",
          },
          textColor: "#F5F5F5",
          textAlign: "center",
          maxWidth: "6xl",
          padding: "py-[89px] px-4",
        },
      },
    ],
  },
  eventos: {
    title: "Eventos - Zero Latency MTY",
    description:
      "Organiza eventos corporativos, cumpleaños y celebraciones especiales en Zero Latency Monterrey.",
    keywords: [
      "eventos",
      "corporativos",
      "cumpleaños",
      "celebraciones",
      "team building",
    ],
    sections: [
      {
        type: "page-banner",
        id: "eventos-banner",
        data: {
          title: "Eventos",
          subtitle: "Entra juntos en una emocionante aventura",
          backgroundImage: "/images/Desktop/Eventos/Eventos-Banner.webp",
          responsiveMedia: {
            desktop: "/images/Desktop/Eventos/Eventos-Banner.webp",
            mobile: "/images/Mobile/Eventos/Eventos-Banner.webp",
          },
        },
      },
      {
        type: "features-section",
        id: "eventos-features",
        data: {
          backgroundColor: "#00202C",
          features: [
            {
              title: "EVENTOS DE EQUIPO Y CORPORATIVOS",
              description:
                "¡Descubre nuevas dimensiones en la manera más emocionante de conectar! Forja vínculos increíbles con tu equipo, clase o tripulación mientras te encuentras con versiones alternativas de vosotros mismos que jamás hubierais imaginado. Sumérgete en dimensiones fantásticas que garantizan fortalecer lazos y crear recuerdos épicos que perdurarán para siempre. Reserva una sala privada o conquista todo el local. Nuestros espacios están diseñados para grupos de cualquier tamaño, creando aventuras que tu equipo recordará toda la vida.",
              image: "/images/Desktop/Eventos/Eventos-Feature1.webp",
            },
            {
              title: "FIESTAS",
              description:
                "¿Tienes algo que celebrar? ¡Conviértelo en un momento legendario con una experiencia única y futurista que dejará a tus invitados alucinados! Reserva una sala privada o conquista todo el local para tu grupo. Desde épicas despedidas de soltero en Outbreak hasta mágicas fiestas infantiles en Engineerum, tenemos la aventura perfecta para grupos de todos los tamaños y edades.",
              image: "/images/Desktop/Eventos/Eventos-Feature2.webp",
            },
          ],
        },
      },
      {
        type: "testimonial-section",
        id: "testimonios-eventos",
        data: {
          topColor: "#00202C",
          bottomColor: "#000",
          backgroundColor: "#F5F5F5",
          autoplay: true,
          autoplaySpeed: 3000,
          showDots: true,
          showArrows: true,
          effect: "slide",
          testimonials: [
            {
              name: "Jonelle",
              text: "¡Vinimos aquí para un evento de equipo y a todos les encantó! Éramos 14 personas, así que nos dividimos en 2 sesiones e hicimos la de zombies en ambas. ¡Recomiendo encarecidamente y definitivamente volveremos! 🧟",
              rating: 5,
              avatar: null,
              position: "Team Event Organizer",
              date: "2023-01-15",
            },
            {
              name: "Carlos",
              text: "Experiencia increíble. La tecnología es impresionante y la inmersión es total. Definitivamente regresaré con mis amigos.",
              rating: 5,
              avatar: null,
              position: "Gamer",
              date: "2023-02-20",
            },
            {
              name: "María",
              text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
              rating: 5,
              avatar: null,
              position: "First-time VR User",
              date: "2023-03-10",
            },
            {
              name: "Ana",
              text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
              rating: 5,
              avatar: null,
              position: "First-time VR User",
              date: "2023-03-10",
            },
            {
              name: "José",
              text: "Nunca había experimentado algo así. Es como estar realmente dentro del juego. ¡Súper recomendado!",
              rating: 5,
              avatar: null,
              position: "First-time VR User",
              date: "2023-03-10",
            },
          ],
        },
      },
    ],
  },
  promociones: {
    title: "Promociones - Zero Latency MTY",
    description:
      "Aprovecha nuestras promociones especiales y descuentos en experiencias de realidad virtual.",
    keywords: ["promociones", "descuentos", "ofertas especiales", "VR"],
    sections: [
      {
        type: "page-banner",
        id: "promociones-banner",
        data: {
          title: "PROMOCIONES",
          subtitle: "¡Descubre ofertas exclusivas y próximos eventos!",
          backgroundImage:
            "/images/Desktop/Promociones/Promociones-Banner.webp",
          responsiveMedia: {
            desktop: "/images/Desktop/Promociones/Promociones-Banner.webp",
            mobile: "/images/Mobile/Promociones/Promociones-Banner.webp",
          },
          ctaButton: {
            text: "¡RESERVA YA!",
            href: "https://booking.zerolatencyvr.com/",
            variant: "solid",
            background: "accent2",
            size: "small",
          },
          height: "60vh",
        },
      },
      {
        type: "features-section",
        id: "ofertas-actuales",
        data: {
          backgroundColor: "#00202C",
          features: [
            {
              title: "Ofertas Especiales",
              description:
                "Estamos entre ofertas locales ahora mismo, ¡pero tranquilo! Increíbles promociones como descuentos para grupos y especiales en horarios flexibles están en camino. ¡Mantente alerta para no perdértelas!",
              image: "/images/Desktop/Promociones/Promociones-Feature1.webp",
            },
            {
              title: "Competiciones y Eventos",
              description:
                "¡Grandes desafíos te esperan con nuevas competiciones y eventos en el ranking! Prepárate para la acción y mantente alerta. ¡No te lo pierdas! Muy pronto te revelaremos más detalles.",
              image: "/images/Desktop/Promociones/Promociones-Feature2.webp",
            },
          ],
          className: "pb-12",
        },
      },
    ],
  },

  //**
  //
  // */ Páginas de Experiencias
  //

  /*//PÁGINA DE VALIDACIÓN (no destructiva)
  "engineerium-preview": {
    title: "Engineerium — Preview Layout",
    description: "Validación del nuevo ExperienceLayout para Engineerium.",
    keywords: ["engineerium", "preview", "experience-layout"],
    sections: [
      {
        type: "experience-layout",
        id: "engineerium-layout",
        data: {
          // Estilos generales del layout
          backgroundColor: "#00202C",

          // Banner/Hero
          banner: {
            description:
              "Un mundo mágico donde tu imaginación no tiene límites",
            gameImage:
              "https://images.ctfassets.net/adsfyhieuvzo/4dS7zv5CD4Nm3QAMm8osGP/84d627ae7baae8dcb073ca0975daf8f1/Engineerium_1366x768_DropShadow_Web.png?fm=webp",
            backgroundImage:
              "https://images.ctfassets.net/adsfyhieuvzo/46UIdIoLIZCXiEA6ciMdde/bbf22f70e608b2d96b60d9ac9e8c1dca/Desktop__2880x1280_.jpg?fm=webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              href: "https://booking.zerolatencyvr.com/",
              variant: "#C5A4F4",
            },
            height: "60vh",
          },

          // Detalles de la experiencia
          details: {
            experienceId: "engineerium",
            backgroundColor: "transparent",
          },

          // Video (sin autoplay por defecto, controles ON)
          video: {
            videoUrl: "https://youtu.be/riswQlQQOb4",
            poster:
              "https://images.ctfassets.net/adsfyhieuvzo/5iOLdoRphZGVXCnJkUC0vk/4d3dd48610f44c30324e644a4121c886/ZeroLatency_ENGINEERIUM_EXPLORER_Character_Experience_tile_350x469_D.jpg?w=720&h=600&fm=webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },

          // Texto
          text: {
            title: "Engineerium",
            description:
              "Un mundo mágico donde tu imaginación no tiene límites",
            textAlign: "center",
            textColor: "#F5F5F5",
            highlightColor: "#C5A4F4",
          },

          // Features (demo)
          features: {
            backgroundColor: "#00202C",
            features: [
              {
                title: "Explora mundos imposibles",
                description:
                  "Rompe la lógica de la gravedad y supera puzzles en equipo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/58NVYT8rYtTRVQzg9CZeTG/96c16ccc75529e52f27206c5ec89a71c/videoframe_2426.png?w=720&h=600&fm=webp",
                layout: "alternate",
              },
              {
                title: "Cooperación y estrategia",
                description:
                  "Perfecto para grupos y familias: comunicación y coordinación.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/0t1OXrcqLw9IuYzYarV6L/d2f0fc9477abf8890d5650c5368949a9/videoframe_3320.png?w=720&h=600&fm=webp",
                layout: "alternate",
              },
              {
                title: "Accesible para todos",
                description:
                  "Dificultad amigable para nuevos jugadores. Ideal como primera experiencia VR.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/MeZOKSbPlmz37DYDCu4IR/4a19ece3b53cc0975a3247c99876a73e/videoframe_1135.png?w=720&h=600&fm=webp",
                layout: "alternate",
              },
            ],
          },

          // Leaderboard (placeholder)
          leaderboard: {
            enabled: true,
            title: "LEADERBOARD TABLE",
            subtitle: "Próximamente",
            backgroundColor: "#00202C",
            textColor: "white",
          },

          // Carrusel de otras experiencias (demo)
          showcase: {
            title: "MÁS EXPERIENCIAS",
            subtitle: "Explora otras aventuras",
            backgroundColor: "#00202C",
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SPACE MARINE",
                description: "Acción cooperativa intensa.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/3UcZCT0MJwPmJARcFvWi5o/c6ee8d8187d9f810841acf4836dce1d5/ZeroLatency_SPACE_MARINE__1_.jpg?w=469&h=350&fm=webp",
              },
            ],
          },

          // CTA final
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            backgroundColor: "#40C0F0",
            title: "¿LISTO PARA JUGAR?",
            description: "Reserva tu sesión y vive Engineerium hoy mismo.",
            ctaButton: {
              text: "¡RESERVA YA!",
              size: "medium",
            },
          },
        },
      },
    ],
  },
   */

  // TRHEAT LETHAL
  "threat-lethal": {
    title: "Threat Lethal - Zero Latency MTY",
    description:
      "Experimenta el combate táctico cooperativo más intenso en realidad virtual.",
    keywords: ["threat lethal", "combate", "táctica", "VR", "Space Marine"],
    sections: [
      // 1) Banner
      {
        type: "page-banner",
        id: "threat-lethal-banner",
        data: {
          description:
            "¿Hasta dónde te atreverás a llegar en este electrizante desafío en equipo?",
          responsiveMedia: {
            desktop:
              "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Banner.webp",
            mobile:
              "/images/Mobile/Experiencias/ThreatLethal/ThreatLethal-Banner.webp",
          },
          backgroundMedia:
            "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Banner.webp",
          gameImage:
            "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Logo.webp",
          ctaButton: {
            text: "¡RESERVA YA!",
            variant: "solid",
            background: "accent3",
            size: "small",
          },
        },
      },
      // 2) Experience details
      {
        type: "experience-details",
        id: "threat-lethal-details",
        data: {
          experienceID: "threat-lethal",
          highlightColor: "accent3",
        },
      },
      // 3) Video
      {
        type: "video-section",
        id: "threat-lethal-video",
        data: {
          // Nota: para reproducción inline usa .mp4 o .m3u8
          // Si subes un mp4, sustituye videoUrl con la ruta al archivo.
          videoUrl: "",
          poster:
            "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-VideoPoster.webp",
          autoplay: false,
          controls: false,
          muted: true,
          backgroundColor: "#00202C",
          textColor: "white",
          textAlign: "center",
          maxWidth: "8xl",
          borderRadius: "lg",
          paddingTop: "py-16",
          paddingBottom: "py-16",
        },
        backgroundColor: "#00202C",
      },
      // 4) Text Section
      {
        type: "text-section",
        id: "threat-lethal-intro",
        data: {
          highlightedText:
            "LUCHA CONTRA LAS HORDAS ALIENÍGENAS POR LA SUPREMACÍA EN",
          highlightedColor: "accent3", // verde #CBFD3C
          title: "SPACE MARINE VR - AMENAZA: LETAL",
          description:
            "¡Derrotar a las hordas alienígenas es ahora más desafiante que nunca! La caída del equipo os devolverá al inicio de cada nivel brutal. El éxito de la misión no está garantizado, y cada intento es una nueva lección de supervivencia. Prepárate para perfeccionar tus estrategias y despertar el verdadero poder táctico de tu escuadrón. Tendréis que trabajar unidos, comunicaros y protegeros mutuamente si queréis sobrevivir a esta peligrosa misión. ",
          ctaButton: {
            text: "¡RESERVA YA!",
            variant: "solid",
            background: "white",
            size: "small",
          },
          textColor: "#F5F5F5",
          textAlign: "center",
          maxWidth: "6xl",
          padding: "py-[89px] px-4",
        },
      },
      // 5) Modes Section
      {
        type: "modes-section",
        id: "threat-lethal-choose-mode",
        data: {
          backgroundColor: "#00202C",
          textColor: "white",
          highlightColor: "accent3",
          title: "SIENTE LA ADRENALINA:",
          subtitle:
            "¿PREPARADO PARA CONVERTIRTE EN UN SPACE MARINE EN EL UNIVERSO DE WARHAMMER 40,000? ¡ELIGE ENTRE ESTAS EXPERIENCIAS ÚNICAS:",
          maxWidth: "6xl",
          items: [
            {
              title: "AMENAZA: MODO EQUIPO LETAL",
              description:
                "Demuestra tus habilidades como Space Marine VR en el modo Threat: Lethal por equipos, una intensa batalla contra reloj de hasta 30 minutos. Si tu escuadrón cae, deberán reiniciar cada brutal nivel, ¡y la victoria no está garantizada!",
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Mode1.webp",
              imageAlt: "Amenaza: Modo Equipo Letal",
            },
            {
              title: "AMENAZA: MODO EQUIPO LETAL EXTRA",
              description:
                "Desafía tus límites y fortalece lazos de amistad en el modo extra por equipos de Threat: Lethal. Unidos contra las hordas alienígenas, tu escuadrón tendrá 15 minutos adicionales de misión. ¿Tienen lo necesario para conquistar esta épica batalla?",
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Mode2.webp",
              imageAlt: "Amenaza: Modo Equipo Letal Extra",
            },
          ],
        },
      },
      // 6) Features Section
      {
        type: "features-section",
        id: "threat-lethal-features-core",
        data: {
          backgroundColor: "#00202C",
          animationsEnabled: true,
          imageStart: "left",
          features: [
            {
              title: "DESATA EL CAOS",
              description:
                "Threat: El modo Letal desafiará tus límites con un reto despiadado que solo dominarás a base de persistencia. Tu equipo deberá reanimar a los compañeros caídos mientras combate contra devastadoras hordas alienígenas. Si fracasas, volverás al inicio del nivel para intentarlo y conquistarlo de nuevo.",
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Feature1.webp",
              imageAlt: "Desata el caos",
              layout: "alternate",
            },
            {
              title: "¿SOBREVIVIRÁN JUNTOS?",
              description:
                "Comunícate y coordínate como nunca antes, enfócate en épicas batallas y solo podrás conseguirlo con la fuerza conjunta de tu equipo. El éxito de tu misión dependerá de la capacidad de tu escuadrón para adaptarse, planear y luchar como un equipo unido e imparable.",
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Feature2.webp",
              imageAlt: "¿Sobrevivirán juntos?",
              layout: "alternate",
            },
            {
              title: "REGRESA, PERFECCIONA, CONQUISTA",
              description:
                "El éxito en Threat: Letal modo equipo hay que conquistarlo, nunca se regala. No todos los equipos lograrán dominar esta épica experiencia. Si no lo consigues a la primera, toma aire y lánzate de nuevo: ahora más fuerte, con experiencia ganada y mejores tácticas.",
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-Feature3.webp",
              imageAlt: "Regresa, perfecciona, conquista",
              layout: "alternate",
            },
          ],
        },
      },
      // 7) News section
      {
        type: "news-cards-section",
        id: "threat-lethal-news",
        data: {
          autoResolve: true,
          section: "threat-lethal",
          imageType: "news",
          title: "NOVEDADES EN THREAT: LETAL",
          subtitle: "",
          backgroundColor: "#00202C",
          textColor: "white",
          textAlign: "left",
          maxWidth: "6xl",
          mobileLayout: "stack",
          cards: [
            {
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-New1.webp",
              imageAlt: "Reanima a tus aliados",
              title: "¡REANIMA A TUS ALIADOS!",
              description:
                "El éxito depende de tu rapidez para reanimar a tus compañeros caídos, porque todo el escuadrón es crucial para devastar las oleadas incesantes de alienígenas.",
            },
            {
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-New2.webp",
              imageAlt: "Tácticas supremas",
              title: "TÁCTICAS SUPREMAS",
              description:
                "Desata el poder de la Granada Aturdidora para frenar las hordas enemigas y arrasar con tus rivales mientras tu equipo avanza imparable.",
            },
            {
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-New3.webp",
              imageAlt: "Renace, reúne, conquista",
              title: "RENACE, REÚNE, CONQUISTA",
              description:
                "Si el equipo cae por completo, el nivel se reinicia y tendrán que intentarlo de nuevo. ¡Vuelve a reunirte con tu escuadrón rápidamente: cada segundo es vital para la misión!",
            },
            {
              image:
                "/images/Desktop/Experiencias/ThreatLethal/ThreatLethal-New4.webp",
              imageAlt: "Mantén la guardia",
              title: "¡MANTÉN LA GUARDIA!",
              description:
                "Cada disparo cuenta. Evita el fuego amigo a toda costa. Un solo movimiento en falso puede costar la vida de tus compañeros y dejar vulnerable a todo tu escuadrón.",
            },
          ],
        },
      },
      // 8) Leaderboard Section
      {
        type: "leaderboard",
        id: "threat-lethal-leaderboard",
        data: {
          highlightText: "GLOBAL",
          highlightColor: "accent3",
          title: "SPACE MARINE VR THREAT LETHAL TEAM MODE CLASIFICACIÓN",
          headerDescription: "Lo mejor de lo mejor.",
          description: "Ver la clasificación de tu lugar más cercano",
          ctaButton: {
            text: "ELIGE TU SEDE",
            variant: "outline",
            size: "small",
            icon: "LocationIcon",
            iconPosition: "left",
          },
          backgroundColor: "#00202C",
          textColor: "white",
          experienceSlug: "threat-lethal",
        },
      },
      // 9) Games Showcase
      {
        type: "games-showcase",
        id: "threat-lethal-showcase",
        data: {
          backgroundColor: "#00202C",
          title: "MÁS EXPERIENCIAS",
          subtitle: "Explora otras aventuras",
          games: [
            {
              title: "OUTBREAK",
              description: "Sobrevive al apocalipsis zombie.",
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
            },
            {
              title: "SINGULARITY",
              description: "Sci-Fi táctico y desafiante.",
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
            },
            {
              title: "SPACE MARINE",
              description: "Acción cooperativa intensa.",
              image:
                "https://images.ctfassets.net/adsfyhieuvzo/3UcZCT0MJwPmJARcFvWi5o/c6ee8d8187d9f810841acf4836dce1d5/ZeroLatency_SPACE_MARINE__1_.jpg?w=469&h=350&fm=webp",
            },
          ],
          ctaButtons: [
            {
              text: "¡RESERVA YA!",
              variant: "solid",
              background: "accent",
              color: "white",
              size: "small",
            },
            {
              text: "MÁS INFORMACIÓN",
              variant: "outline",
              color: "white",
              size: "small",
            },
          ],
        },
      },
      // 10) CTA Section
      {
        type: "c-t-a-wave",
        id: "threat-lethal-cta",
        data: {
          bottomColor: "#000000",
          title: "DESATA TU ESPÍRITU AVENTURERO",
          description: "¡ENCONTRARÁS ALGO PARA TODOS!",
          ctaButton: {
            text: "¡RESERVA YA!",
            size: "small",
          },
          layout: "center",
        },
      },
    ],
  },
  // SPACE MARINE VR
  "space-marine": {
    title: "Space Marine VR — Zero Latency MTY",
    description:
      "Acción cooperativa intensa en el universo de Warhammer 40,000.",
    keywords: ["space marine", "vr", "coop", "warhammer"],
    sections: [
      {
        type: "experience-layout",
        id: "space-marine-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description:
              "Encarna a un Marine Espacial de Warhammer 40,000 y desata tu furia",
            responsiveMedia: {
              desktop:
                "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Banner.webp",
              mobile:
                "/images/Mobile/Experiencias/SpaceMarine/SpaceMarine-Banner.webp",
            },
            backgroundMedia:
              "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Banner.webp",
            gameImage:
              "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Logo.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              href: "https://booking.zerolatencyvr.com/",
              variant: "accent2",
              size: "small",
            },
            height: "60vh",
            imageAlt: "Space Marine Banner",
          },
          details: {
            experienceId: "space-marine",
            backgroundColor: "transparent",
            highlightColor: "accent2",
          },
          video: {
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText:
              "ÚNICAMENTE EN VENUES ZERO LATENCY VR ALREDEDOR DEL MUNDO",
            highlightedColor: "accent2",
            title: "SPACE MARINE VR",
            description:
              "Directo desde el universo de Warhammer 40,000, el esperadísimo Space Marine VR: Defensores de Avarax llega con fuerza a los centros Zero Latency VR de todo el mundo. Disponible a partir del 25 de septiembre de 2024.",
            textAlign: "center",
            textColor: "white",
            maxWidth: "6xl",
            layout: "column",
          },
          features: {
            backgroundColor: "#00202C",
            imageStart: "left",
            features: [
              {
                title: "UNA AMENAZA IMPLACABLE",
                description:
                  "Eres un Marine Espacial. Un supersoldado mejorado genéticamente. Un guerrero indomable forjado en la disciplina más absoluta. En las profundidades de la inmensa Ciudad Colmena de Fervastium, deberás adentrarte en una cámara acorazada para cumplir una misión vital. Si lo consigues, podrás desencadenar el giro decisivo en la batalla y ayudar a repeler a los Tiránidos, una devastadora horda alienígena que surge desde más allá de la galaxia conocida.",
                image:
                  "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Feature1.webp",
                imageAlt: "Space Marine Feature 1",
                layout: "alternate",
              },
              {
                title: "DESATA TU GUERRERO INTERIOR",
                description:
                  "En la oscuridad más profunda del futuro lejano, el enemigo es implacable. No existe la paz. No hay descanso. No hay perdón. Solo existe la guerra. Empuñando un formidable arsenal del universo Warhammer 40,000, enfréntate a las voraces hordas de Tiránidos. Alístate para la batalla y sumérgete en épicos combates donde las probabilidades están en tu contra.",
                image:
                  "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Feature2.webp",
                imageAlt: "Space Marine Feature 2",
                layout: "alternate",
              },
              {
                title: "NUESTRO MUNDO MÁS GRANDE JAMÁS CREADO",
                description:
                  "En una realidad virtual alucinante donde la realidad ha sido desgarrada, prepárate para sentir la adrenalina pura corriendo por tus venas. Sumérgete en espacios extraordinarios mientras exploras el electrizante universo de Warhammer 40,000 como nunca antes lo habías soñado. En un futuro consumido por la guerra, reúne a tus compañeros para crear momentos épicos en una aventura tan intensa que supera toda imaginación.",
                image:
                  "/images/Desktop/Experiencias/SpaceMarine/SpaceMarine-Feature3.webp",
                imageAlt: "Space Marine Feature 3",
                layout: "alternate",
              },
            ],
          },
          leaderboard: {
            enabled: true,
            title: "SPACE MARINE VR — CLASIFICACIÓN",
            backgroundColor: "#00202C",
            textColor: "white",
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            // Opcional: botones de acción bajo el carrusel
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "LIBERA TU SED DE AVENTURA",
            description: "¡HAY UNA AVENTURA PARA CADA UNO DE USTEDES!",
            ctaButton: {
              variant: "solid",
              background: "primary",
              text: "¡RESERVA YA!",
              size: "small",
              href: "https://booking.zerolatencyvr.com/",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // FAR CRY VR
  "far-cry": {
    title: "Far Cry VR — Zero Latency MTY",
    description: "Explora una isla tropical llena de peligros y aventuras.",
    keywords: ["far cry", "vr", "aventura", "supervivencia"],
    sections: [
      {
        type: "experience-layout",
        id: "far-cry-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description:
              "Desata una emoción sin límites en tu emocionante fuga hacia la libertad",
            gameImage: "/images/Desktop/Experiencias/FarCry/FarCry-Logo.webp",
            backgroundImage:
              "/images/Desktop/Experiencias/FarCry/FarCry-Banner.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              href: "https://booking.zerolatencyvr.com/",
              variant: "accent2",
            },
            height: "60vh",
          },
          details: {
            experienceId: "far-cry",
            backgroundColor: "transparent",
            highlightColor: "accent2",
          },
          video: {
            // Cuando tengas un mp4/m3u8, reemplaza videoUrl para habilitar la reproducción
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/FarCry/FarCry-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText: "DESATA TUS INSTINTOS PRIMARIOS",
            highlightedColor: "secondary",
            title: "DESPIERTA AL SUPERVIVIENTE QUE LLEVAS DENTRO",
            description:
              "Cuando te aventuraste a explorar la jungla, jamás imaginaste toparte con una banda de piratas sedientos de acción, ansiosos por convertirte en su presa. Necesitas escapar, ¡AHORA MISMO! Enfréntate a ellos desde las góndolas suspendidas, busca refugio en misteriosas cuevas y libra una batalla épica en las profundidades del corazón de la jungla.",
            textAlign: "center",
            textColor: "#F5F5F5",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "solid",
              background: "white",
              size: "small",
            },
          },
          features: {
            backgroundColor: "#00202C",
            imageStart: "left",
            features: [
              {
                title: "BIENVENIDO A LAS ISLAS SUNNY ROOK",
                description:
                  "No te dejes engañar por el paraíso de aguas cristalinas y arenas doradas como mantequilla — esta no es una escapada tropical. Lánzate a la aventura en góndolas tambaleantes para sobrevivir. Disfruta del paisaje, pero mantente alerta: los enemigos están al acecho detrás de cada esquina, caja y palmera.",
                image:
                  "/images/Desktop/Experiencias/FarCry/FarCry-Feature1.webp",
                imageAlt: "Far Cry Feature 1",
                layout: "alternate",
              },
              {
                title: "Aventúrate por misteriosas cavernas",
                description:
                  "Atrévete a aventurarte por esta ruta más rápida hacia el templo, pero recuerda: el peligro acecha en cada paso. Los hongos luminiscentes que iluminan tu camino son engañosos y pueden jugar con tu mente. ¡Mantén tus sentidos alerta!",
                image:
                  "/images/Desktop/Experiencias/FarCry/FarCry-Feature2.webp",
                imageAlt: "Far Cry Feature 2",
                layout: "alternate",
              },
              {
                title: "Enfréntate a tus enemigos",
                description:
                  "Te has adentrado en lo más profundo de la jungla, y la banda de Vaas te tiene rodeado. Es hora de controlar tu pulso acelerado, despertar tu poder interior, desatar tu furia — y contraatacar sin piedad.",
                image:
                  "/images/Desktop/Experiencias/FarCry/FarCry-Feature3.webp",
                imageAlt: "Far Cry Feature 3",
                layout: "alternate",
              },
            ],
          },
          leaderboard: {
            enabled: true,
            title: "FAR CRY VR — CLASIFICACIÓN",
            backgroundColor: "#00202C",
            textColor: "white",
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            // Opcional: botones de acción bajo el carrusel
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // OUTBREAK
  outbreak: {
    title: "Outbreak — Zero Latency MTY",
    description: "Sobrevive al apocalipsis zombie en equipo.",
    keywords: ["outbreak", "zombies", "vr", "supervivencia"],
    sections: [
      {
        type: "experience-layout",
        id: "outbreak-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description: "Sobrevive al apocalipsis zombie en equipo",
            responsiveMedia: {
              desktop:
                "/images/Desktop/Experiencias/Outbreak/Outbreak-Banner.webp",
              mobile: "/images/Mobile/home/HomeBanner.webp",
            },
            backgroundMedia:
              "/images/Desktop/Experiencias/Outbreak/Outbreak-Banner.webp",
            gameImage:
              "/images/Desktop/Experiencias/Outbreak/Outbreak-Logo.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "solid",
              background: "accent",
              size: "small",
            },
            height: "60vh",
          },
          details: {
            experienceId: "outbreak",
            highlightColor: "accent",
            backgroundColor: "transparent",
          },
          video: {
            // Cuando tengas un mp4/m3u8, reemplaza videoUrl para habilitar la reproducción
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/Outbreak/Outbreak-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          // No hay póster de video en assets -> omitimos el bloque 'video'
          text: {
            highlightedText: "ENFRÉNTATE A HORDAS DE ZOMBIS SEDIENTOS DE CARNE",
            highlightedColor: "secondary",
            title: "DESPIERTA A TU HÉROE INTERIOR",
            description:
              "En pleno caos del apocalipsis zombi global, el destino te ha elegido como guardián de la única cura existente.Cuando tu laboratorio es infiltrado, deberás enfrentarte a hordas implacables de muertos vivientes, controlar los latidos de tu corazón mientras te adentras sigilosamente en hospitales abandonados, abrirte paso a tiros por sótanos pantanosos y desafiar alturas mortales. Todo en una misión explosiva cargada de adrenalina para salvar a la humanidad.",
            textAlign: "center",
            textColor: "#F5F5F5",
          },
          features: {
            backgroundColor: "#00202C",
            features: [
              {
                title: "¡ESCAPA DE LAS ALCANTARILLAS!",
                description:
                  "Lo único peor que encontrarte en las profundidades putrefactas del sistema de alcantarillas es tener que sobrevivir a una horda interminable de zombis despiadados. Protege a tu equipo o enfréntate solo a la amenaza — ¡pero sal de ahí cuanto antes!",
                image:
                  "/images/Desktop/Experiencias/Outbreak/Outbreak-Feature1.webp",
                imageAlt: "Outbreak Feature 1",
                layout: "alternate",
              },
              {
                title: "Alza el vuelo",
                description:
                  "Libera al héroe que llevas dentro y siente la adrenalina recorrer tu cuerpo mientras te lanzas a un helicóptero y te elevas sobre una ciudad devastada, envuelta en llamas y estruendo de batalla.",
                image:
                  "/images/Desktop/Experiencias/Outbreak/Outbreak-Feature2.webp",
                imageAlt: "Outbreak Feature 2",
                layout: "alternate",
              },
              {
                title: "¡La épica batalla final por la gloria!",
                description:
                  "Los no muertos no son tu único desafío. Mantente alerta ante los mercenarios armados y enfréntate incluso a un helicóptero en combate. Este es el momento de demostrar tu valía.",
                image:
                  "/images/Desktop/Experiencias/Outbreak/Outbreak-Feature3.webp",
                imageAlt: "Outbreak Feature 3",
                layout: "alternate",
              },
            ],
          },
          leaderboard: {
            enabled: true,
            title: "OUTBREAK — CLASIFICACIÓN",
            backgroundColor: "#00202C",
            textColor: "white",
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // SINGULARITY
  singularity: {
    title: "Singularity — Zero Latency MTY",
    description: "Sci-Fi táctico y desafiante.",
    keywords: ["singularity", "vr", "sci-fi", "táctico"],
    sections: [
      {
        type: "experience-layout",
        id: "singularity-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description: "Sci-Fi táctico y desafiante",
            gameImage:
              "/images/Desktop/Experiencias/Singularity/Singularity-Logo.webp",
            backgroundImage:
              "/images/Desktop/Experiencias/Singularity/Singularity-Banner.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              href: "https://booking.zerolatencyvr.com/",
              variant: "#C5A4F4",
            },
            height: "60vh",
          },
          details: {
            experienceId: "singularity",
            backgroundColor: "transparent",
            highlightColor: "accent2",
          },
          video: {
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/Singularity/Singularity-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText: "HUMANO CONTRA MÁQUINA",
            highlightedColor: "secondary",
            title: "DESPIERTA AL LÍDER QUE HAY EN TI",
            description:
              "Cuando la base secreta sea infiltrada, tú y tu escuadrón tendrán que luchar contra robots armados y feroces drones de ataque para recuperar el control total de la situación.",
            textAlign: "center",
            textColor: "#F5F5F5",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "solid",
              background: "white",
              size: "small",
            },
          },
          features: {
            backgroundColor: "#00202C",
            features: [
              {
                title: "¡Toma el control!",
                description:
                  "Cuando se corta la energía, no hay tiempo que perder. Unidades infinitas de robots asesinos avanzan implacablemente desde todas las direcciones. Tienes segundos para planear tu estrategia, así que prepárate para tomar el mando o seguir las órdenes de tu equipo — tu supervivencia y la de tu equipo dependen de ello.",
                image:
                  "/images/Desktop/Experiencias/Singularity/Singularity-Feature1.webp",
                imageAlt: "Singularity Feature 1",
                layout: "alternate",
              },
              {
                title: "¡Mantén la calma y domina el juego!",
                description:
                  "Despierta tu determinación oculta mientras te aventuras valientemente por pasillos estrechos y ascensores desafiantes para conquistar tu destino final. Recuerda, tienes una misión épica por cumplir.",
                image:
                  "/images/Desktop/Experiencias/Singularity/Singularity-Feature2.webp",
                imageAlt: "Singularity Feature 2",
                layout: "alternate",
              },
              {
                title: "Descubre al infiltrado que amenaza la base",
                description:
                  "¡Has descubierto el origen del problema, y ahora es tu momento de actuar! Es hora de convertirte en héroe y desatar al líder que hay dentro de ti: tu equipo cuenta contigo para triunfar.",
                image:
                  "/images/Desktop/Experiencias/Singularity/Singularity-Feature3.webp",
                imageAlt: "Singularity Feature 3",
                layout: "alternate",
              },
            ],
          },
          leaderboard: {
            enabled: true,
            title: "SINGULARITY — CLASIFICACIÓN",
            backgroundColor: "#00202C",
            textColor: "white",
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            // Opcional: botones de acción bajo el carrusel
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // UNDEAD ARENA
  "undead-arena": {
    title: "Undead Arena — Zero Latency MTY",
    description: "Arena de combate contra no-muertos.",
    keywords: ["undead arena", "vr", "arena", "combate"],
    sections: [
      {
        type: "experience-layout",
        id: "undead-arena-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description: "Enfréntate a hordas de no-muertos",
            gameImage:
              "/images/Desktop/Experiencias/UndeadArena/UndeadArena-VR.webp",
            backgroundImage:
              "/images/Desktop/Experiencias/UndeadArena/UndeadArena-Banner.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "accent",
              size: "small",
            },
            height: "60vh",
          },
          details: {
            experienceId: "undead-arena",
            backgroundColor: "transparent",
            highlightColor: "accent2",
          },
          video: {
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/UndeadArena/UndeadArena-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText: "LUZ, CÁMARA, ACCIÓN",
            highlightedColor: "secondary",
            title: "DESPIERTA TU ARTISTA INTERIOR",
            description:
              "¡Enféntate a los zombis bajo las luces de neón y vive la batalla más espectacular! Desafía al miedo y conquista la arena con tu propio estilo. Déjate llevar por la energía del presentador mientras su voz hace vibrar cada rincón del escenario. No hay escape posible, ¡así que da el show de tu vida y haz que el público enloquezca!",
            textAlign: "center",
            textColor: "#F5F5F5",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "solid",
              background: "white",
              size: "small",
            },
          },
          features: {
            backgroundColor: "#00202C",
            imageStart: "left",
            features: [
              {
                title: "¡Desata tu creatividad!",
                description:
                  "Interactúa con los diferentes letreros de neón para desatar trampas mortales y espectaculares explosiones que mantendrán a raya la interminable oleada de muertos vivientes. No te sientas mal si empiezas a disfrutarlo.",
                image:
                  "/images/Desktop/Experiencias/UndeadArena/UndeadArena-Feature1.webp",
                imageAlt: "Undead Arena Feature 1",
                layout: "alternate",
              },
              {
                title: "¡Desata la locura!",
                description:
                  "Las plataformas y puentes móviles te darán el poder de conquistar cada rincón. ¡La arena completa es tu territorio de batalla, aprovecha cada centímetro! Muévete, salta y gira con total libertad mientras liberas tu espíritu guerrero. ¿Despertarás al campeón que llevas dentro o desatarás tu lado más estratégico y salvaje? ¡El momento de la verdad ha llegado!",
                image:
                  "/images/Desktop/Experiencias/UndeadArena/UndeadArena-Feature2.webp",
                imageAlt: "Undead Arena Feature 2",
                layout: "alternate",
              },
              {
                title: "Reclama tu corona",
                description:
                  "¡Compara tus puntuaciones finales con las de tu equipo! Presumir de tus logros no solo está permitido... ¡es parte de la diversión!",
                image:
                  "/images/Desktop/Experiencias/UndeadArena/UndeadArena-Feature3.webp",
                imageAlt: "Undead Arena Feature 3",
                layout: "alternate",
              },
            ],
          },
          leaderboard: {
            enabled: true,
            title: "UNDEAD ARENA — CLASIFICACIÓN",
            backgroundColor: "#00202C",
            textColor: "white",
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // SOL RAIDERS
  "sol-raiders": {
    title: "Sol Raiders — Zero Latency MTY",
    description: "Aventura espacial de acción y estrategia.",
    keywords: ["sol raiders", "vr", "sci-fi", "acción"],
    sections: [
      {
        type: "experience-layout",
        id: "sol-raiders-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description: "Aventura espacial de acción y estrategia",
            gameImage:
              "/images/Desktop/Experiencias/SolRaiders/SolRaiders-Logo.webp",
            backgroundImage:
              "/images/Desktop/Experiencias/SolRaiders/SolRaiders-Banner.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "accent",
              size: "small",
            },
            height: "60vh",
          },
          details: {
            experienceId: "sol-raiders",
            highlightColor: "accent",
            backgroundColor: "transparent",
          },
          video: {
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/SolRaiders/SolRaiders-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText: "CONQUISTA LA GLORIA CON TU EQUIPO",
            highlightedColor: "secondary",
            title: "DESPIERTA TU ESTRATEGA INTERIOR",
            description:
              "¡Divídete en dos equipos y lucha por la victoria en tres escenarios llenos de adrenalina! Conquista los objetivos, manténte con vida y alcánzala: ¡la gloriosa victoria será tuya!",
            textAlign: "center",
            textColor: "#F5F5F5",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "solid",
              size: "small",
              background: "white",
            },
          },
          features: {
            backgroundColor: "#00202C",
            features: [
              {
                title: "Tres emocionantes mapas únicos",
                description:
                  "Supera tus miedos en la Estación de Turbinas, desata tu lado más astuto en el Naufragio Oscuro y arrésgalo todo en el soleado Cañón Minero. Aunque cada zona te plantea un desafío único, la misión es siempre la misma: conquista puntos con tu equipo y vive la adrenalina de la victoria.",
                image:
                  "/images/Desktop/Experiencias/SolRaiders/SolRaiders-Feature1.webp",
                imageAlt: "Sol Raiders Feature 1",
                layout: "alternate",
              },
              {
                title: "Tres objetivos únicos",
                description:
                  "Cada experiencia es única en cada ubicación, pero tu misión es clara y emocionante: lidera la defensa de tu equipo, domina el objetivo o conviértete en el héroe que distrae al equipo rival. Sumérgete en una trepidante misión donde cada punto te acerca a la victoria final. ¡La adrenalina está garantizada!",
                image:
                  "/images/Desktop/Experiencias/SolRaiders/SolRaiders-Feature2.webp",
                imageAlt: "Sol Raiders Feature 2",
                layout: "alternate",
              },
              {
                title: "Cobra venganza, demuestra tu gloria",
                description:
                  "Es imposible resistirse a la gloria, ¿por qué rendirse ante tanta adrenalina? Vuelve una y otra vez, conquista nuevas estrategias y forma equipos diferentes. No hay sensación más electrizante que reinar en lo más alto de la clasificación.",
                image:
                  "/images/Desktop/Experiencias/SolRaiders/SolRaiders-Feature3.webp",
                imageAlt: "Sol Raiders Feature 3",
                layout: "alternate",
              },
            ],
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
  // ENGINEERIUM
  engineerium: {
    title: "Engineerium — Zero Latency MTY",
    description: "Un mundo mágico donde tu imaginación no tiene límites.",
    keywords: ["engineerium", "vr", "rompecabezas", "fantasía"],
    sections: [
      {
        type: "experience-layout",
        id: "engineerium-layout",
        data: {
          backgroundColor: "#00202C",
          sectionGap: "",
          banner: {
            description:
              "Un mundo mágico donde tu imaginación no tiene límites",
            gameImage:
              "/images/Desktop/Experiencias/Engineerium/Engineerium-Logo.webp",
            backgroundImage:
              "/images/Desktop/Experiencias/Engineerium/Engineerium-Banner.webp",
            ctaButton: {
              text: "¡RESERVA YA!",
              variant: "accent2",
              size: "small",
            },
            height: "60vh",
          },
          details: {
            experienceId: "engineerium",
            backgroundColor: "transparent",
            highlightColor: "accent2",
          },
          video: {
            videoUrl: "",
            poster:
              "/images/Desktop/Experiencias/Engineerium/Engineerium-VideoPoster.webp",
            backgroundColor: "#00202C",
            controls: true,
            autoplay: false,
            muted: true,
          },
          text: {
            highlightedText: "DESATA TU CURIOSIDAD",
            highlightedColor: "secondary",
            title: "DESATA TU IMAGINACIÓN",
            description:
              "¿Listo para desafiar la gravedad? Has llegado a una dimensión asombrosa. Aventúrate por un sendero fantástico entre las nubes, donde te esperan vistas espectaculares y visiones mágicas por descubrir. Mientras tú y tu equipo os sumergís en este mundo de maravillas para reunir a una tribu perdida, ¡no dejéis que las alturas os mareen!",
            textAlign: "center",
            textColor: "#F5F5F5",
            maxWidth: "6xl",
            layout: "column",
          },
          features: {
            backgroundColor: "#00202C",
            imageStart: "left",
            features: [
              {
                title: "¡Trabajemos juntos!",
                description:
                  "¡Trabajando unidos es la clave para conquistar cada paso! Descubre caminos misteriosos mientras asciendes por rampas y atraviesas plataformas flotantes. No mires hacia abajo... a menos que te atrévete a contemplar las hipnóticas aguas cristalinas que brillan muy, muy lejos en las profundidades.",
                image:
                  "/images/Desktop/Experiencias/Engineerium/Engineerium-Feature1.webp",
                imageAlt: "Engineerium Feature 1",
                layout: "alternate",
              },
              {
                title: "Sumérgete por completo",
                description:
                  "Déjate maravillar por este fantástico mundo y despierta tu imaginación mientras flotas en un mágico paisaje tecnicolor entre las nubes. ¡No dudes en saludar a las místicas criaturas marinas que nadan por el cielo junto a ti, son increíblemente amigables!",
                image:
                  "/images/Desktop/Experiencias/Engineerium/Engineerium-Feature2.webp",
                imageAlt: "Engineerium Feature 2",
                layout: "alternate",
              },
              {
                title: "¡Un reencuentro emocionante!",
                description:
                  "¡La tribu celebra tu heroico esfuerzo! Únete al festejo y déjate llevar por la danza, la música y el espectáculo de luces — ¡te has ganado esta gloriosa celebración!",
                image:
                  "/images/Desktop/Experiencias/Engineerium/Engineerium-Feature3.webp",
                imageAlt: "Engineerium Feature 3",
                layout: "alternate",
              },
            ],
          },
          showcase: {
            backgroundColor: "#00202C", // usa hex de tu branding
            textColor: "white",
            title: "SIENTE LA ADRENALINA",
            subtitle: "Encontrarás aventuras para todos los gustos",
            showDots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            games: [
              {
                title: "OUTBREAK",
                description: "Sobrevive al apocalipsis zombie.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/50TkzwCqYcnD3rclElHCWh/14899394cd4cdb8eede543e93b4cce99/ZeroLatency_OUTBREAK_SURVIVOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "SINGULARITY",
                description: "Sci-Fi táctico y desafiante.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/2067c5FkQDiLWTipISbwlb/6af96ee4a6d30dda45f07a11ccbbaa4b/ZeroLatency_SINGULARITY_COMPETITOR_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
              {
                title: "THREAT LETHAL",
                description: "Misión táctica de alto riesgo.",
                image:
                  "https://images.ctfassets.net/adsfyhieuvzo/L9dEDSKvfYWvQVhUGTLkq/d8b9e71e0b5e9cb0487a1e63be008998/ZeroLatency_SOL_RAIDERS_TACTICIAN_Character_Experience_tile_350x469_D.jpg?w=469&h=350&fm=webp",
              },
            ],
            ctaButtons: [
              {
                text: "¡RESERVA YA!",
                variant: "solid",
                background: "accent",
                color: "white",
                size: "small",
              },
              {
                text: "MÁS INFORMACIÓN",
                variant: "outline",
                color: "white",
                size: "small",
              },
            ],
          },
          cta: {
            topColor: "#00202C",
            bottomColor: "#000000",
            title: "¿QUIERES TENER TU PROPIO ZERO LATENCY?",
            description:
              "Únete a nuestra apasionada comunidad global de aventureros que están revolucionando el entretenimiento.",
            ctaButton: {
              text: "¡RESERVA YA!",
              background: "primary",
              size: "small",
            },
            layout: "center",
          },
        },
      },
    ],
  },
};
